import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class ResponsiveService {
  private _responsive = inject(BreakpointObserver);

  public isMobilePortrait$ = this._responsive
    .observe([Breakpoints.HandsetPortrait])
    .pipe(map((value: BreakpointState) => value.matches));
  public isMobile$ = this._responsive
    .observe([Breakpoints.Handset])
    .pipe(map((value: BreakpointState) => value.matches));
  public isWeb$ = this._responsive
    .observe([Breakpoints.Web])
    .pipe(map((value: BreakpointState) => value.matches));
}
